module.exports = __webpack_public_path__ + "img/right.1947517d.png";